module.exports = __webpack_public_path__ + "static/media/callus.27e3af2d.png";